import styled from "styled-components";
import { SectionWrapper } from "shared/Styles/Wrappers";
import { Paragraph } from "components/Typography";

export const Wrapper = styled(SectionWrapper)`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
`;

export const Title = styled.h3`
    font-size: 4rem;
    line-height: 1;
    font-weight: 800;
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        font-size: 3rem;
    }
    @media screen and (max-width: ${({ theme }) =>
            theme.breakpoints.tablet_big}) {
        font-size: 2.4rem;
    }
`;

export const Text = styled(Paragraph)`
    max-width: 740px;
    width: 100%;
    line-height: 1.6;
    color: ${({ color }) => (color ? color : "#000")};
`;

export const Container = styled.div`
    padding: 124px 0;
    width: 100%;
    background: ${({ background }) => (background ? background : "#fff")};
    color: ${({ color }) => (color ? color : "#000")};

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        padding: 64px 0;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding: 36px 0;
    }

    &.marketing {

        padding: 40px 0;

        ${Title} {
            font-size: 3rem;
        }

        ${Wrapper} {
            align-items: center;
        }

        ${Text} {

            &.bigText {

                font-size: 7rem;
                font-weight: 800;

                @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
                    font-size: 6rem;
                }

                @media screen and (max-width: ${({ theme }) =>
                        theme.breakpoints.tablet_big}) {
                    font-size: 5rem;
                }

                @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
                    font-size: 4rem;
                }

                @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
                    font-size: 3rem;
                }
            }
        }

        @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
            padding: 34px 0;

            ${Title} {
                font-size: 2.5rem;
            }

            ${Text} {
                margin-left: 32px;
            }
        }

        @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet_big}) {
            padding: 24px 0;
            ${Title} {
                font-size: 2rem;
            }
        }

        @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {

            ${Text} {
                margin-left: 0px;
            }
        }

        @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone}) {

            text-align: center;
        }

    }
`;

export const TitleBox = styled.div`
    width: 33%;

    &.sticky {
        position: sticky;
        top: 70px;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        width: 40%;
    }

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        padding-right: 0;

        &.sticky {
            position: static;
        }
    }
`;

export const TextWrapper = styled.div`
    width: 67%;
    display: flex;
    justify-content: flex-end;

    @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
        width: 60%;
    }
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        margin-top: 24px;
    }
`;


